import { IServiceBook } from './../../../_models/profile-sections/IServiceBook';
import { IProfile } from './../../../_models/account/IProfile';
import { ISpouseOutInfo } from './../../../_models/profile-sections/ISpouseOutInfo';
import { SpouseOutInfoService } from './../../../shared/services/spouse-out-info.service';
import { ISpouseInInfo } from './../../../_models/profile-sections/ISpouseInInfo';
import { SpouseInInfoService } from './../../../shared/services/spouse-in-info.service';
import { ISingleWomenInfo } from './../../../_models/profile-sections/ISingleWomenInfo';
import { SingleWomenInfoService } from './../../../shared/services/single-women-info.service';
import { IDiseaseInfo } from './../../../_models/profile-sections/IDiseaseInfo';
import { DiseaseInfoService } from './../../../shared/services/disease-info.service';
import { DisabledInfoService } from './../../../shared/services/disabled-info.service';
import { IDisabledInfo } from './../../../_models/profile-sections/IDisabledInfo';
import { TransferRequestService } from './../../../shared/services/transfer-request.service';
import { ITransferRequest } from './../../../_models/transfer-sections/ITransferRequest';
import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';

@Component({
  selector: 'app-transfer-request-view',
  templateUrl: './transfer-request-view.component.html',
  styleUrls: ['./transfer-request-view.component.css']
})
export class TransferRequestViewComponent implements OnInit {
  skeleton: boolean = true;
  pic: string = "/assets/img/extra/img_avatar.png";
  sin: string = "/assets/img/extra/img_sign.png";
  transferRequest: ITransferRequest;
  constructor(
    private service: TransferRequestService,
    private disabledInfoService: DisabledInfoService,
    private diseaseInfoService: DiseaseInfoService,
    private singleWomenInfoService: SingleWomenInfoService,
    private spouseInInfoService: SpouseInInfoService,
    private spouseOutInfoService: SpouseOutInfoService,
    private toastrService: ToastrService,
    private router: Router,) { }

  ngOnInit(): void {
    this.getTransferRequest();
  }

  getTransferRequest() {
    this.service.logged().subscribe((response: ITransferRequest) => {
      if (response) {
        this.transferRequest = response;
        this.pic = response?.profile?.profileThumb?.photo?.mediaUrl;
        this.sin = response?.profile?.profileThumb?.sign?.mediaUrl;
        this.getDisabledInfo();
        this.getDiseaseInfo();
        this.getSingleWomenInfo();
        this.getSpouseInInfo();
        this.getSpouseOutInfo();
      }
    },
      (error) => console.log('HTTP Error', error),
      () => this.skeleton = false);
  }

  getDisabledInfo() {
    this.disabledInfoService.logged().subscribe((response: IDisabledInfo) => {
      if (response) {
        this.transferRequest.profile.disabledInfos.push(response);
      }
    });
  }
  getDiseaseInfo() {
    this.diseaseInfoService.logged().subscribe((response: IDiseaseInfo) => {
      if (response) {
        this.transferRequest.profile.diseaseInfos.push(response);
      }
    });
  }
  getSingleWomenInfo() {
    this.singleWomenInfoService.logged().subscribe((response: ISingleWomenInfo) => {
      if (response) {
        this.transferRequest.profile.singleWomenInfos.push(response);
      }
    });
  }
  getSpouseInInfo() {
    this.spouseInInfoService.logged().subscribe((response: ISpouseInInfo) => {
      if (response) {
        this.transferRequest.profile.spouseInInfos.push(response);
      }
    });
  }
  getSpouseOutInfo() {
    this.spouseOutInfoService.logged().subscribe((response: ISpouseOutInfo) => {
      if (response) {
        this.transferRequest.profile.spouseOutInfos.push(response);
      }
    });
  }

  getCategories(item: IProfile) {
    let transferCategories: string = "";
    let presentPlace: IServiceBook = item.serviceBooks.find(x => x.isPresent);
    if (item.disabledInfos[0]) {
      transferCategories = transferCategories + "PH <br/>";
    }
    if (item.diseaseInfos[0]) {
      transferCategories = transferCategories + " Medical <br/>";
    }
    if (this.isPresentHard(presentPlace)) {
      transferCategories = transferCategories + " H/VH/SH <br/>";
    }
    if (this.isPresentPlan(presentPlace) && !item.disabledInfos[0] && !item.diseaseInfos[0] && !item.singleWomenInfos[0] && !item.spouseOutInfos[0] && !item.spouseInInfos[0] && !item.isRetirementNear) {
      transferCategories = transferCategories + " Plane <br/>";
    }
    if (item.singleWomenInfos[0]) {
      transferCategories = transferCategories + " Single Lady <br/>";
    }
    if (item.spouseInInfos[0]) {
      transferCategories = transferCategories + " NVS Spouse <br/>";
    }
    if (item.spouseOutInfos[0]) {
      transferCategories = transferCategories + " Central/State Spouse <br/>";
    }
    if (item?.isRetirementNear) {
      transferCategories = transferCategories + " Due For Retirement (DFR) <br/>";
    }
    return transferCategories;
  }

  isPresentHard(presentPlace: IServiceBook) {
    return presentPlace ? (presentPlace.school.schoolTypeId > 1 ? true : false) : false;
  }
  isPresentPlan(presentPlace: IServiceBook) {
    return presentPlace ? (presentPlace.school.schoolTypeId == 1 ? true : false) : false;
  }

  confirm() {
    if (!confirm('Are you sure you want to lock this application?')) return;

    this.service.confirm().subscribe(() => {
      this.toastrService.success('application locked successfully.');
      this.router.navigate(['/employee']);
    });
  }
}
